import React, { useState } from "react";
import sampleLogo from "../../assets/logo/sample1.png";
import { ChevronDown, Menu, X, Phone, Download } from "lucide-react";
import { Button } from "../../components/ui/button";

export const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const features = [
    "Proforma Invoice",
    "Contract for Export Business",
    "Tax and Custom Invoice",
    "Commercial Invoice",
    "Packing List",
  ];
  // const resources = ["Blog", "Video", "Podcast", "Testimonial"];
  // const industries = ["Spices", "Automotive", "Yarn", "Textiles and Garments"];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: "smooth" });
    setActiveDropdown(null);
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="bg-white border-b border-slate-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <div
              className="flex items-center gap-2 cursor-pointer"
              onClick={() => scrollToSection("hero")}
            >
              <img
                src={sampleLogo}
                alt="Export Stuff"
                className="h-8 w-auto max-w-[250px] object-contain"
              />
            </div>
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection("hero")}
              className="text-slate-700 hover:text-blue-600 font-medium"
            >
              Home
            </button>
            <div className="relative">
              <button
                onMouseEnter={() => setActiveDropdown("features")}
                onMouseLeave={() => setActiveDropdown(null)}
                className="flex items-center gap-1 text-slate-700 hover:text-blue-600 font-medium"
              >
                Features
                <ChevronDown className="w-4 h-4" />
              </button>
              {activeDropdown === "features" && (
                <div className="absolute top-full left-0 w-64 bg-white border rounded mt-2 p-4">
                  {features.map((f, i) => (
                    <div key={i}>
                      <button
                        onClick={() => scrollToSection("features")}
                        className="text-sm text-slate-600 py-1"
                      >
                        {f}
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <button
              onClick={() => scrollToSection("pricing")}
              className="text-slate-700 hover:text-blue-600 font-medium"
            >
              Pricing
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              className="text-slate-700 hover:text-blue-600 font-medium"
            >
              Contact
            </button>
            <div className="flex items-center gap-2 text-slate-700 font-medium">
              <Phone className="w-4 h-4" />
              <span>+91 8000007329</span>
            </div>
            <Button variant="outline" className="flex items-center gap-2">
              <Download className="w-4 h-4" />
              Download Brochure
            </Button>
          </div>

          <div className="lg:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-slate-700 hover:text-blue-600"
            >
              {isMobileMenuOpen ? (
                <X className="w-6 h-6" />
              ) : (
                <Menu className="w-6 h-6" />
              )}
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden border-t border-slate-200 py-4">
            <div className="space-y-2">
              <button
                onClick={() => scrollToSection("hero")}
                className="block w-full text-left px-4 py-2"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection("features")}
                className="block w-full text-left px-4 py-2"
              >
                Features
              </button>
              <button
                onClick={() => scrollToSection("pricing")}
                className="block w-full text-left px-4 py-2"
              >
                Pricing
              </button>
              <button
                onClick={() => scrollToSection("contact")}
                className="block w-full text-left px-4 py-2"
              >
                Contact
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
